var map = {
	"./bg.png": 1769,
	"./bird.png": 6165,
	"./fg.png": 2437,
	"./getready.png": 4937,
	"./go.png": 9746,
	"./pipeNorth.png": 7219,
	"./pipeSouth.png": 737
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1598;